// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.fees.singlefamily.RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_create,
  RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_delete,
  RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get,
  RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get_Path,
  RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType,
  RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType_Path,
  RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_update,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  CreateSingleFamilyFeesRequestDto,
  FeeType,
  GetSingleFamilyFeesResponseDto,
  ListingAlias,
  MultiErrorsResponseDto,
  SingleFamilyFeeDto,
  UpdateSingleFamilyFeesRequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface DeleteParams {
  costAndFeeId: string;
  listingAlias: ListingAlias;
}
interface GetParams {
  listingAlias: ListingAlias;
}
interface GetFeesForTypeParams {
  feeType: FeeType;
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_create_Args {
  postData: CreateSingleFamilyFeesRequestDto;
}

export type RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_create_Options = UseMutationOptions<
  MultiErrorsResponseDto<SingleFamilyFeeDto>,
  unknown,
  RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_create_Args
>;

/**
 * Creates a fee for a single family listing
 */
export const useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_create_Args) =>
      RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_create(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_delete_Args
>;

/**
 * Deletes a fee for a single family listing
 */
export const useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_delete_Args) =>
      RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_delete(args.getParams, httpClient),
  });
};

export type RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get_Options = UseQueryOptions<
  GetSingleFamilyFeesResponseDto,
  unknown,
  GetSingleFamilyFeesResponseDto,
  readonly [string, GetParams]
>;

const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get_GetKey = (getParams: GetParams) =>
  [RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get_Path, getParams] as const;

export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get_queryOptions = (
  getParams: GetParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Retrieve all fees for a given single family listing
 */
export const useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get = (
  getParams: GetParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get.getKey =
  RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get_GetKey;

export type RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType_Options = UseQueryOptions<
  Array<SingleFamilyFeeDto>,
  unknown,
  Array<SingleFamilyFeeDto>,
  readonly [string, GetFeesForTypeParams]
>;

const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType_GetKey = (
  getParams: GetFeesForTypeParams,
) => [RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType_Path, getParams] as const;

export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType_queryOptions = (
  getParams: GetFeesForTypeParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Deletes a fee for a single family listing
 */
export const useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType = (
  getParams: GetFeesForTypeParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType.getKey =
  RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType_GetKey;

export interface RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_update_Args {
  postData: UpdateSingleFamilyFeesRequestDto;
}

export type RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_update_Options = UseMutationOptions<
  MultiErrorsResponseDto<SingleFamilyFeeDto>,
  unknown,
  RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_update_Args
>;

/**
 * Update a fee for a single family listing
 */
export const useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_update = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_update_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_update_Args) =>
      RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_update(args.postData, httpClient),
  });
};
